import React, { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { GrMapLocation } from "react-icons/gr";
import { applyOpportunity } from "../../helper/opportunity";
import { isAuthenticated } from "../../helper/authApiCalls/auth";

const OpportunityPop = ({ selectedOpportunity, isOpen, closeModal, toast }) => {
  const [skills, setSkills] = useState([]);
  const [file, setFile] = useState();
  const [dataAppy, setDataApply] = useState({
    phone: "",
    answer: "",
  });

  useEffect(() => {
    setSkills([]);
  }, [isOpen]);

  const changeHandler = (e) => {
    setDataApply({ ...dataAppy, [e.target.name]: e.target.value });
  };

  async function handleKeyDown(e) {
    if (e.key === "Enter" && e.target.value !== "") {
      setSkills([...skills, e.target.value]);
      e.target.value = "";
    }
  }

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    setSkills([]);
  }, [isOpen]);

  async function apply(e) {
    console.log(file);
    e.preventDefault();
    let formData = await new FormData();
    formData.append("skills", skills);
    formData.append("name", isAuthenticated().name);
    formData.append("email", isAuthenticated().email);
    formData.append("phone", dataAppy.phone);
    formData.append("answer", dataAppy.answer);
    formData.append("resume", file);

    const data = await applyOpportunity(formData, selectedOpportunity._id);

    if (data.success === true) {
      closeModal();
      toast.success(data.message);
    } else {
      toast.error(data.message);
    }
  }

  return (
    <div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto noscrollbar">
            <div className="flex min-h-full items-center  justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md noscrollbar  h-[550px] overflow-y-scroll transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-2xl font-medium leading-6 text-gray-900 "
                  >
                    {selectedOpportunity?.jobTitle}
                  </Dialog.Title>
                  <div className="mt-2 ">
                    <p className="text-xl text-gray-500">
                      {selectedOpportunity?.jobDescription}
                    </p>
                  </div>
                  <div className="text-[18px] font-[500] mt-2  flex items-center ">
                    <GrMapLocation className="text-[24px] pr-1" />{" "}
                    {selectedOpportunity?.jobLocation}
                  </div>
                  <div className="text-[18px] font-[500]    mt-2">
                    {selectedOpportunity?.jobType}
                  </div>
                  <div className="text-[18px] font-[500]    mt-2">
                    Email : {selectedOpportunity?.email}
                  </div>
                  <div className="text-[18px] font-[500]   mt-2">
                    PhoneNumber : {selectedOpportunity?.phone}
                  </div>
                  <div className="text-[18px] font-[500]   mt-2">
                    Add Your Skills
                  </div>

                  <input
                    type="text"
                    className="px-2 py-2 mt-2 rounded-md border w-full"
                    rows={1}
                    name="question"
                    onKeyDown={handleKeyDown}
                  />

                  <div className="mt-2 flex items-center">
                    {skills.length > 0 &&
                      skills.map((skill, index) => {
                        return (
                          <button className="bg-black text-white px-2 py-1 rounded-md mr-1">
                            {skill}
                          </button>
                        );
                      })}
                  </div>
                  <div className="text-[18px] font-[500]   mt-2">
                    Add Your Resume
                  </div>
                  <div className="mt-2">
                    <input
                      type="file"
                      className="px-2 py-2 mt-2 rounded-md border w-full"
                      name="question"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="text-[18px] font-[500]   mt-2">
                    Add Your PhoneNumber
                  </div>
                  <div className="mt-2">
                    <input
                      type="number"
                      className="px-2 py-2 mt-2 rounded-md border w-full"
                      name="phone"
                      onChange={changeHandler}
                    />
                  </div>
                  <div className="text-[18px] font-[500]    mt-2">
                    Question : {selectedOpportunity?.question}
                  </div>

                  <textarea
                    type="text"
                    className="px-2 py-2 rounded-md border w-full"
                    rows={4}
                    // onChange={(e) => handleOpportunity(e)}
                    name="answer"
                    onChange={changeHandler}
                  />
                  <div className="w-full my-3">
                    <button
                      onClick={apply}
                      className="text-center w-full bg-black text-white py-3 rounded-[20px] hover:bg-gray-800"
                    >
                      Apply
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default OpportunityPop;
